import type { HelpCenterAudience } from "../../interfaces/models/IHelpCenter";
import { HELP_CENTER_AUDIENCE_LABELS } from "./helpCenterUtils";

type HelpCenterAudienceTabsProps = {
  audiences: HelpCenterAudience[];
  activeAudience: HelpCenterAudience;
  onChange: (audience: HelpCenterAudience) => void;
  staffTheme?: boolean;
  className?: string;
};

export default function HelpCenterAudienceTabs({
  audiences,
  activeAudience,
  onChange,
  staffTheme = false,
  className = "",
}: HelpCenterAudienceTabsProps) {
  if (audiences.length === 0) {
    return null;
  }

  return (
    <div
      className={`help-center-audience-tabs${
        staffTheme ? " help-center-audience-tabs-staff" : ""
      }${className ? ` ${className}` : ""}`}
      role="tablist"
      aria-label="Help Center audience"
    >
      {audiences.map((audience) => {
        const isActive = audience === activeAudience;
        return (
          <button
            key={audience}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`help-center-audience-tab${
              isActive ? " help-center-audience-tab-active" : ""
            }`}
            onClick={() => onChange(audience)}
          >
            {HELP_CENTER_AUDIENCE_LABELS[audience]}
          </button>
        );
      })}
    </div>
  );
}
